import api from "../service/solicitacao.service";
import * as types from "./solicitacao.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put } from "redux-saga/effects";
import solicitacaoActions from "../../solicitacao/store/solicitacao.actions";
import dadosCadastraisActions from "../../dadosCadastrais/store/dadosCadastrais.actions";
import dadosSolicitanteActions from "../../dadosSolicitante/store/dadosSolicitante.actions";
import enderecoPrincipalActions from "../../enderecoPrincipal/store/enderecoPrincipal.actions";
import enderecoCobrancaActions from "../../enderecoCobranca/store/enderecoCobranca.actions";
import cnaeActions from "../../cnae/store/cnae.actions";
import atividadeActions from "../../atividades/store/atividade.actions";
import historicosActions from "../../historico/store//historico.actions";
import camposDinamicosActions from "../../camposDinamicos/store/camposDinamicos.actions";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.RESET_FORM, resetForm);
}

function* resetForm(action) {
  const { payload } = action;

  if (payload.resetTotal) {
    if (
      payload.disabledTipoSolicitacao == undefined ||
      payload.disabledTipoSolicitacao
    ) {
      yield put(
        solicitacaoActions.setSolicitacao({
          Numero: undefined,
          CCM: "",
          TipoSolicitacao: payload.TipoSolicitacao,
          CpfCnpjSolicitacao: payload.cnpjCpf,
          DescricaoSolicitacao: "",
          disableTipoSolicitacao: true,
          SituacaoSolicitacaoDescricao: "Aguardando Avaliação",
          itensComboboxCCM: [],
          solicitacoes: []
        })
      );
    } else {
      yield put(
        solicitacaoActions.setSolicitacao({
          Numero: undefined,
          CCM: "",
          TipoSolicitacao: payload.TipoSolicitacao,
          CpfCnpjSolicitacao: payload.cnpjCpf,
          DescricaoSolicitacao: "",
          disableTipoSolicitacao: false,
          SituacaoSolicitacaoDescricao: "Aguardando Avaliação",
          solicitacoes: []
        })
      );
    }
  } else if (payload.TipoSolicitacao != "") {
    if (
      payload.disabledTipoSolicitacao != undefined &&
      !payload.disabledTipoSolicitacao
    ) {
      return;
    }
    yield put(solicitacaoActions.setCCMTipoSolicitacao(payload));
  } else if (payload.TipoSolicitacao == "")
    yield put(solicitacaoActions.setReducerCcmDisabled(true));

  yield put(dadosCadastraisActions.dadosCadastraisResetForm());

  yield put(enderecoPrincipalActions.resetForm());
  yield put(enderecoCobrancaActions.resetForm());
  yield put(camposDinamicosActions.resetFormDinamico());
  yield put(cnaeActions.setCnae([]));
  yield put(atividadeActions.setAtividade([]));
  yield put(historicosActions.setHistorico([]));
  yield put(formActions.gridReload());
}
